<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>公司全称：</p>
        <el-input v-model="fullNameIpt" size="mini" style="width:150px" placeholder="请输入公司全称"/>
      </div>
<!--      <div class="navContainer" style="width: 230px">-->
<!--        <p>所在区域：</p>-->
<!--        <el-cascader v-model="addressIpt" :options="regionList" style="width:150px" :props="{-->
<!--                        expandTrigger: 'hover',-->
<!--                        value: 'id',-->
<!--                        label: 'cityName',-->
<!--                        children: 'children',-->
<!--                        multiple: false,-->
<!--                      }" size="mini" collapse-tags filterable clearable placeholder="请选择所在区域" ref="areaCascader"-->
<!--        />-->
<!--      </div>-->
      <div class="navContainer" style="width: 240px">
        <p>负责人姓名：</p>
        <el-input v-model="nameIpt" size="mini" style="width:150px" placeholder="请输入负责人姓名"/>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="fullName" label="公司全称" align="center"/>
          <el-table-column prop="simpleName" label="公司简称" align="center"/>
          <el-table-column prop="phone" label="联系电话" align="center"/>
<!--          <el-table-column prop="address" label="所在区域" width="199" align="center"/>-->
          <el-table-column prop="addressDetail" label="详细地址" align="center" width="200">
            <template slot-scope="scope">
              <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{scope.row.addressDetail}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="leader" label="负责人姓名" align="center"/>
          <el-table-column prop="leaderPhone" label="负责人电话" align="center"/>
          <el-table-column label="状态" align="center" width="120">
            <div slot-scope="scope">{{getState(scope.row.status)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
              <div>
                <el-button v-if="scope.row.status" size="mini" type="danger" @click="disableClick(scope.row.id)">禁用</el-button>
                <el-button v-else size="mini" type="primary" @click="enableClick(scope.row.id)">启用</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情分公司" :visible.sync="detailDialogVisible" width='650px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p :style="`color:${detailData.status?'rgba(51, 136, 255, 1)':'#f78989'}`">{{getState(detailData.status)}}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">公司全称：</span>
              <span>{{detailData.fullName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">关键词：</span>
              <span>{{detailData.keyword}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">公司简称：</span>
              <span>{{detailData.simpleName}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">公司电话：</span>
                <span>{{detailData.phone}}</span>
              </div>
              <div>
                <span class="span1">公司邮箱：</span>
                <span>{{detailData.mailbox}}</span>
              </div>
            </div>
<!--            <div class="baseInfoContentItem">-->
<!--              <span class="span1">所在区域：</span>-->
<!--              <span>{{detailData.address}}</span>-->
<!--            </div>-->
            <div class="baseInfoContentItem">
              <span class="span1">详细地址：</span>
              <span>{{detailData.addressDetail}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">负责人姓名：</span>
                <span>{{detailData.leader}}</span>
              </div>
              <div>
                <span class="span1">负责人电话：</span>
                <span>{{detailData.leaderPhone}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <transition name="el-fade-in-linear">
      <popup :title="dialogTitle" :show.sync="dialogVisible" width='550' center @close="dialogClose" :close-on-click-modal="false">
      <div class="company" >
        <el-form :model="companyData" label-width="95px" :rules="rules" ref="ruleForm">
          <el-form-item label="账号：" prop="account" v-if="dialogTitle!=='修改分公司'">
            <el-input
              :style="'width:100%'"
              v-model="companyData.account"
              placeholder="请输入分公司账号"
              autocomplete="off"
              size="small"/>
            <!-- <hr color="#F0F0F2"/> -->
          </el-form-item>
          <el-form-item label="密码：" prop="password" v-if="dialogTitle!=='修改分公司'">
            <el-input
              :style="'width:100%'"
              v-model="companyData.password"
              placeholder="请输入分公司密码"
              autocomplete="off"
              size="small"
              show-password
            />
            <!-- <hr color="#F0F0F2"/> -->
          </el-form-item>
          <el-form-item label="公司全称：" prop="fullName">
            <el-input
              :style="'width:100%'"
              v-model="companyData.fullName"
              placeholder="请输入分公司全称"
              autocomplete="off"
              size="small"
            />
            <!-- <hr color="#F0F0F2"/> -->
          </el-form-item>
          <el-form-item label="关键词：" prop="keyword">
            <el-input
              :style="'width:100%'"
              v-model="companyData.keyword"
              placeholder="请输入关键词"
              autocomplete="off"
              size="small"
            />
            <!-- <hr color="#F0F0F2"/> -->
          </el-form-item>
          <el-form-item label="公司简称：" prop="referred">
            <el-input
              :style="'width:100%'"
              v-model="companyData.referred"
              placeholder="请输入分公司简称"
              autocomplete="off"
              size="small"
            />
            <!-- <hr color="#F0F0F2"/> -->
          </el-form-item>
          <el-form-item label="联系电话：" prop="tell">
            <el-input
              :style="'width:100%'"
              v-model="companyData.tell"
              placeholder="请输入分公司联系电话"
              autocomplete="off"
              size="small"
            />
            <!-- <hr color="#F0F0F2"/> -->
          </el-form-item>
<!--          <el-form-item label="所在区域：" prop="area">-->
<!--            <el-cascader v-model="companyData.area" :options="regionList" style="width:100%" :props="{-->
<!--                        expandTrigger: 'hover',-->
<!--                        value: 'id',-->
<!--                        label: 'cityName',-->
<!--                        children: 'children',-->
<!--                        multiple: false,-->
<!--                      }" collapse-tags clearable filterable placeholder="请选择所在区域" ref="areaCascader"-->
<!--            />-->
<!--            <hr color="#F0F0F2"/>-->
<!--          </el-form-item>-->
          <el-form-item label="详细地址：" prop="address">
            <div style="display: flex;cursor: pointer;align-items: center;" @click="mapVisible=true">
              <el-input
                :disabled="true"
                style="width:90%;margin-right: 10px;"
                v-model="companyData.address"
                placeholder="点击选择分公司详细地址"
                autocomplete="off"
                size="small"
              />
              <i class="el-icon-location"/>
            </div>
            <!-- <hr color="#F0F0F2"/> -->
          </el-form-item>
          <el-form-item label="负责人姓名：" prop="name">
            <el-input
              :style="'width:100%'"
              v-model="companyData.name"
              placeholder="请输入分公司负责人姓名"
              autocomplete="off"
              size="small"
            />
            <!-- <hr color="#F0F0F2"/> -->
          </el-form-item>
          <el-form-item label="负责人电话：" prop="nameTell">
            <el-input
              :style="'width:100%'"
              v-model="companyData.nameTell"
              placeholder="请输入分公司负责人电话"
              autocomplete="off"
              size="small"
            />
            <!-- <hr color="#F0F0F2"/> -->
          </el-form-item>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="loading" @click="addClick">{{dialogTitle==='新增分公司'?'新增':'修改'}}</el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </popup>
    </transition>
    <transition name="el-fade-in-linear">
      <popup width="850" title="详细地址" :show.sync="mapVisible" center>
        <web-map :useType="'select'" @close="mapClose" v-if="mapVisible" :address="companyData.address"/>
      </popup>
    </transition>
  </div>
</template>

<script>
import webMap from '@/components/map'
import popup from "@/components/popup";
import {formatDateTime, getSessionStore, removeSpace} from "@/config/mUtils";
import {addCompany, companyDetail, companyIsEnable, companyList, updateOrganization} from "@/service/basicfile"
import {getRegionName} from "@/service/getData"

export default {
  components: {
    webMap,
    popup,
  },
  data() {
    const validateTell = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系手机号'));
      } else if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    const validateAccount = (rule, value, callback) => {

        callback();

    };
    const validatePassword  = (rule, value, callback) => {

        callback();

    };

    return {
      mapVisible:false,
      fullNameIpt:'',
      addressIpt:'',
      nameIpt:'',
      stateIpt:'',
      stateOption:[
        {value:'',label:'全部',},
        {value:1,label:'启动中',},
        {value:0,label:'禁用中',},
      ],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[],
      detailDialogVisible:false,
      detailData:{},
      operationData:[],
      dialogTitle:'',
      dialogVisible:false,
      companyData:{
        fullName:'',
        keyword:'',
        referred:'',
        tell:'',
        area:'',
        address:'',
        name:'',
        nameTell:'',
        account:'',
        password:''
      },
      loading:false,
      rules:{
        fullName:[
          { required: true, message: '请输入分公司全称', trigger: 'blur' },
        ],
        account:[
          { required: true, message: '请输入分公司账号', trigger: 'blur' },
        ],
        password:[
          { required: true, message: '请输入分公司密码', trigger: 'blur' },
        ],
        referred:[
          { required: true, message: '请输入分公司简称', trigger: 'blur' },
        ],
        keyword:[
          { required: true, message: '请输入关键词', trigger: 'blur' },
        ],
        tell:[
          { required: true, validator:validateTell,trigger: 'blur' },
        ],
        area:[
          { required: true, message: '请输入分公司所在区域', trigger: 'change' },
        ],
        address:[
          { required: true, message: '请输入分公司详细地址', trigger: 'blur' },
        ],
        name:[
          { required: true, message: '请输入分公司负责人姓名', trigger: 'blur' },
        ],
        nameTell:[
          { required: true,validator:validateTell, trigger: 'blur' },
        ],
      },
      regionList: [],
    };
  },
  mounted() {
    this._companyList();
    this.regionList = JSON.parse(getSessionStore("areaList"));
  },
  computed:{
    getState(){
      return function(state){
        switch(state) {
          case 1:
            return '启用中'
          case 0:
            return '禁用中'
        }
      };
    },
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
  },
  methods: {
    async _companyList(){
      this.tableLoad=true;
      let str='';
      if(this.addressIpt)
        this.addressIpt.forEach((item,index)=>{
          if(index!==this.addressIpt.length-1) str+=item+',';
          else str+=item;
        })
      const obj={
        orgNm:this.fullNameIpt,
        regionId:str,
        leader:this.nameIpt,
        status:this.stateIpt,
        rows:this.size,
        page:this.page,
      };
      const res = await companyList(obj);
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total;
    },
    mapClose(val, lnglat){
      if (!val || !lnglat[0] || !lnglat[1]) {
        this.$message.error("获取地址失败");
        return;
      }
      console.log(val,'val')
      console.log(lnglat,'lnglat')
      this.companyData.address=val;
      this.companyData.coordinates = lnglat;
      this.mapVisible=false;
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._companyList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._companyList();
    },
    disableClick(id){
      this.$confirm('确定要禁用分公司吗？禁用后，分公司将不可登录或其它操作！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await companyIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._companyList();
      }).catch(() => {});
    },
    async detailClick(id){
      const res = await companyDetail(id);
      if(res.status !== 0) return this.$message.error(res.message);
      this.operationData=res.data.operateRecordList;
      this.detailData=res.data;
      this.detailDialogVisible=true;
    },
    async changeClick(item){
      const res = await companyDetail(item.id);
      if(res.status !== 0) return this.$message.error(res.message);
      // const arr =[];
      // res.data.regionId.split(',').forEach(item=>arr.push(Number(item)))
      this.companyData={
        ...res.data,
        fullName:res.data.fullName,
        referred:res.data.simpleName,
        tell:res.data.phone,
        address:res.data.addressDetail,
        name:res.data.leader,
        nameTell:res.data.leaderPhone,
        coordinates:[res.data.longitude,res.data.dimension]
        // area:arr,
      };

      this.dialogTitle='修改分公司';
      this.dialogVisible=true;
    },
    searchBtn(){
      this.page = 1;
      this._companyList();
    },
    resetBtn(){
      this.fullNameIpt='';
      this.addressIpt='';
      this.nameIpt='';
      this.stateIpt='';
    },
    addBtn(){
      this.dialogTitle='新增分公司';
      this.dialogVisible=true;
      this.companyData={
        fullName:'',
        keyword:'',
        referred:'',
        tell:'',
        area:'',
        address:'',
        name:'',
        nameTell:'',
        account:'',
        password:''
      };
    },
    addClick(){
      this.companyData=removeSpace(this.companyData);
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          // let str='';
          // this.companyData.area.forEach((area,index) =>{
          //   if(index !== this.companyData.area.length-1) str+=area+',';
          //   else str+=area
          // });
          // const res2 = await getRegionName(str);
          // if(res2.status !== 0) return this.$message.error(res2.message);
          const obj={
            id:this.companyData.id,
            fullName:this.companyData.fullName,
            keyword:this.companyData.keyword,
            simpleName:this.companyData.referred,
            phone:this.companyData.tell,
            account:this.dialogTitle!=='修改分公司'?this.companyData.account:'',
            password:this.dialogTitle!=='修改分公司'?this.companyData.password:'',
            // regionId:str,
            // address:res2.data,
            addressDetail:this.companyData.address,
            longitude:this.companyData.coordinates[0],
            dimension:this.companyData.coordinates[1],
            leader :this.companyData.name,
            leaderPhone:this.companyData.nameTell,
          };
          this.loading = true
          const res = this.dialogTitle==='新增分公司'?await addCompany(obj):await updateOrganization(obj);
          if(res.status !== 0) {
            this.loading = false;
            return this.$message.error(res.message);
          }
          this.$message.success(res.message);
          this.loading = false
          await this._companyList();
          this.dialogVisible=false;
        } else return false;
      });
    },
    enableClick(id){
      this.$confirm('确定要启用分公司吗？启用后，分公司将可登录并操作数据！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await companyIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._companyList();
      }).catch(() => {});
    },
    dialogClose(){
      this.dialogVisible=false;
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }  
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
        .el-table th>.cell{
          font-weight: 700!important;
        }
        .el-loading-mask{
          z-index: 1020;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px;
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        // border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
